import {connect} from '../../app/connect';
import '../../assets/styles/app.scss';
import {getIframeUrl, getIframeTitle} from '../../app/selectors';
import {closeIframe} from '../../app/actions';
import ControllableIFrameModal from './ControllableIFrameModal';

const mapStateToProps = state => ({
  iframeUrl: getIframeUrl(state),
  iframeTitle: getIframeTitle(state)
});

const mapDispatchToProps = {
  closeIframe
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ControllableIFrameModal);
